"use strict";
exports.__esModule = true;
exports.SvgNotificationsHover = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgNotificationsHover = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 14 14" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "#727272", fillRule: "nonzero", d: "M8 11.5a.75.75 0 01.102 1.493L8 13H6a.75.75 0 01-.102-1.493L6 11.5h2zM7 1c2.28 0 4.13 1.798 4.13 4.015v2.403c0 .6.254.95.697 1.32l.351.277c.63.492.273 1.985-.536 1.985H2.358c-.809 0-1.167-1.493-.536-1.985l.212-.166c.53-.414.837-.771.837-1.43V5.014C2.87 2.798 4.72 1 7 1z" }),
        react_1["default"].createElement("path", { d: "M0 0h14v14H0z" })))); };
//# sourceMappingURL=NotificationsHover.js.map